export const EN = {
  banner: {
    error: "Quotes are not updated, please wait",
    copicate: "Try out the new Portfolio mode!",
    antimonitor: "Best place to Buy and Trade Cryptocurrency Click here!",
  },
  footer: {
    donating: "If you like CoinTrackr, please consider donating!",
    right_reserve:
      "© Copyright " +
      new Date().getFullYear() +
      " by CoinTrackr.com. Some rights reserved.",
    version: "Version",
    changelog: "Changelog",
    powered_by: "Powered by",
  },
  top: {
    about: {
      info: "Info",
      FAQ: "FAQ",
      contact: "Contact",
      partners: "Partners",
      terms: "Terms",
      privacy: "Privacy",
    },
  },
  content: {
    valuation: {
      current_valuation: "Current Valuation",
      approx: "Approx.",
    },
    profit_losses: "Profits & Losses",

    updating_assets: " Updating assets...",
    updated_now: "Last updated just now",
    last_update: `Last updated {time} seconds ago`,
    last_update_minutes: `Last updated {minutes} min {seconds} sec ago`,
  },
  assets: {
    your_assets: "Assets",
    add_asset: "Add asset",
    sort: "Sort by",
    sort_name: {
      name: "Name",
      exchId: "Exchange",
      price: "Price",
      value: "Valuation",
      holdings: "Holdings",
      percChangeHour: "Hour",
      percChangeDay: "Day",
      percChangeWeek: "Week",
    },
  },
  charts: {
    color_help: "Click on a circle to change a color",
  },
  contact_page: {
    contact: "Contact",
    help_feedback: "Help & Feedback",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium:",
    busines: "Business Inquiries",
    email: "Email",
  },
  partner_page: {
    partners: "Our Partners",
    bitsify:
      "Bitsify provides complete detailed upcoming ICO and Crowdsale Reports.",
    bitcoin:
      "Bitcoin for Beginners is Your beginner-friendly community for learning about cryptocurrency.",
    interest: "Interested in partnership?",
    contact_us: "Contact us!",
  },
  user_menu: {
    not_logged: "Not logged in",
    icognito: "Incognito",
    settings: "Settings",
    sign_in: "Sign in",
    sign_out: "Sign out",
    valuation: "Show valuation in the tab",
    incognito: "Incognito Mode",
    night_mode: "Night mode",
    share_link: "Create shareable link",
  },
  FAQ: {
    expand: "Expand all",
    collapse: "Collapse all",
    0: {
      title: "What is CoinTrackr?",
      text:
        "CoinTrackr is a free, simple and convenient service designed to help to track cryptocurrency investments.",
    },
    1: {
      title: "How do I create my own portfolio on CoinTrackr?",
      text:
        "This is simple one! Just remove the assets of the example portfolio and replace with your own. You can remove or edit an asset by clicking it.",
    },
    2: {
      title: "Where do CoinTrackr get the coin prices and are they accurate?",
      text:
        'All the price data comes from <a href="https://coinmarketcap.com">coinmarketcap.com</a>, and represents the average price between the exchanges that are supported by CoinMarketCap. Because CoinTrackr uses average prices, they might differ slightly from the exact price of the exchange you are following.',
    },
    3: {
      title: "How can I add my API key and Trading from Cointrackr?",
      text:
        'Just follow instruction in our dedicated page <a href="/exchange/how-it-works">here</a>.',
    },
    4: {
      title: "Do you plan to add more Exchange?",
      text:
        "Yes, we plan to add as much of Exchange possible who offer possibility to generate API Key for their clients.",
    },
    5: {
      title: "What's the valuation and how do you determine the amount?",
      text:
        "Valuation is the total value of all your assets added to CoinTrackr; the total worth of your current crypto portfolio.",
    },
    6: {
      title: "Why can't I find some coins?",
      text:
        "If you spelled the name of the coin right and it can't be found, it seems like CoinMarketCap does not support the coin yet. We are working on adding multiple sources for price data, so it is very likely that your coin will be supported in the future.",
    },
    7: {
      title: "How do you store my portfolio and login data?",
      text:
        "If you are not logged in, all the data is saved on your browser cache. You can close the window and come back later, without a need to add your assets again." +
        "\n" +
        "If you have registered on CoinTrackr (social login/email and password), your data is stored on our database. We do this to make possible real time syncing between your different devices (e.g. desktop and mobile) and for the data to be stored even if you clear browser cache.",
    },
    8: {
      title: "Is it safe to create CoinTrackr account?",
      text:
        'Yes. We only use your data to make possible the key functioning of CoinTrackr. We do not give any of your data to third parties in any situation. Please check our <a href="/privacy">Privacy Policy<a/> for more detailed info.',
    },
    9: {
      title:
        "Would CoinTrackr be interested in cooperation with my crypto related service/community?",
      text:
        'Possibly. Please <a href="/contact">contact<a/> us to discuss about possibilities!',
    },
  },
  add_page: {
    search: "Search by name or symbol",
    add_asset: "Add Asset",
    any_asset: {
      1: "Any asset (coin or token) that is listed on",
      2: "is supported.",
    },
    next: "Next",
    no_result: "No results found for",
  },
  register_page: {
    register: "Register",
    agree: "By registering, you agree to our",
    terms: "Terms & Conditions",
    and: "and",
    privacy: "Privacy Policy",
    p_reg:
      "Registering is required if you want to <b>save your portfolio</b> to use on <b>other devices</b>, or protect you from losing it <b>in case you clear your browser cache</b>.",
    errors: {
      email_required: "Email is required.",
      email_valid: "Email must be a valid email.",
      password_required: "Password is required.",
      password_length: "Password must have at least {length} characters.",
      password_match: "Passwords have to match.",
    },
    placeholder: {
      email: "Type in your email",
      password: "Type in your password",
      password_repeat: "Repeat your password",
    },
    create_account: "Create account",
  },
  login_page: {
    placeholder: {
      email: "Type in your email",
      password: "Type in your password",
    },
    errors: {
      email_not_found:
        "There is no user record corresponding to this identifier. The user may have been deleted.",
      not_email: "The email address is badly formatted.",
    },
    forget_password_text: "If you forget your password, click here to reset it",
    forget_password_text_back: "back to Sign in",
    reset_password: "Reset Password",
    reset_password_p:
      "Enter your e-mail address below and we will send you an e-mail to reset your password.",
    reset_password_success:
      "Password Reset message for CoinTrackr has been sent. Check your inbox and come back.",
    // forget_password_text: 'If you forget your password, please send us an Email to: <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> to reset it',
  },
  share_page: {
    heading: "Create shareable link",
    just_second: "Just a second...",
    porfolio_not_found: "Portfolio not found",

    p_1:
      "<strong>CoinTrackr</strong> is a free <strong>cryptocurrency portfolio manager</strong> that allows you to follow your profits and losses and <strong>share your portfolio with others</strong>.",
    create_own: "Create yours for free",

    p_2:
      "<strong>Somebody shared their portfolio with you!</strong> <br> CoinTrackr is a free cryptocurrency portfolio service supporting over 4,000 coins and tokens.",
    porfolio: "Portfolio",
    profit_losed: "Profits & Losses",

    created: "Created",
    dialog: {
      p_1:
        "Sharing your portfolio creates a <strong>public link</strong> that shows your <strong>anonymous portfolio</strong>. It contains <strong>only percentages</strong> and no valuation or prices. It cannot be tied back to you and is completely safe to share with anybody.",
      add_message: "<strong>Add a message</strong> <em>(optional)</em>",
    },
    create_shareble: "Create shareable link",
    create_own_free: "Create your own portfolio",
    messages: {
      already: "Your portfolio link is ready to share! 🙌",
      copied: "Your link was copied! 🎉",
      not_copied: "Your link could not be copied. Please copy manually. 😢",
      failed: "Link creation failed, please try again. 😢",
    },
  },
  global: {
    add_first: "Add your first asset",

    not_now: "Not now",
    not_right_now: "Not right now",
    close: "Close",
    go_back: "Go back",
    share: "%Share",

    price: "Price",

    day: "Day",
    hour: "Hour",
    week: "Week",
    valuation: "Valuation",
    holdings: "Holdings",
    name: "Name",
    actions: "Actions",
    edit: "Edit",
    notes: "Notes",

    last_7_days: "Last 7 days",
    last_24_hour: "Last 24 hours",
    last_hour: "Last hour",

    login: "Login",
  },
  sign_in_dialog: {
    button: {
      email: "Sign in with Email",
      facebook: "Sign in with Facebook",
      google: "Sign in with Google",
      twitter: "Sign in with Twitter",
    },
    p:
      "Signing in is required if you want to <b>save your portfolio</b> to use on <b>other devices</b>, or protect you from losing it <b>in case you clear your browser cache</b>.",
  },
  notifications: {
    sign_in: "You are now signed in.",
    sign_out: "You are now signed out.",
    HODL: "Y U NO HODL? 😭",
    dont_worry: "Don't worry, be happy now... and HOOOOODL 🎶 🚀",
  },
  edit_asset_page: {
    add: "Add or Edit",
    how_much: "How much {assetName} {assetSymbol} do you hold?",
    save: "Save",
    delete: "Delete",
    notes_label: "Notes for {assetName} {assetSymbol}",
    notes_placeholder:
      "Add here your notes like Purchase price, Exchange, Wallet address or any other comment related to the asset",
  },
  exchange: {
    exchange: "Exchange",
    trade: "Trade",

    your_api_keys: "Your API keys",
    how_it_works: "How it works?",

    home_valuation_per_exchange: "Valuation per Exchange",
    home_show_valuation_per_exchange: "Show Valuation per Exchange",
    home_tooltip_info: "See the info about Exchange API Keys",

    api_key: "API key",
    secret: "Secret",
    add: "Add",
    update: "Update",
    cancel: "Cancel",
    add_your_exchange_api_key: "Add your {exchange} API Key",
    add_exchange_api_key: "Add {exchange} API Key",
    update_exchange_api_key: "Update {exchange} API Key",
    api_keys_page_note:
      "Important: There is a 15mn refresh delay from Binance after a deposit / withdrawal and any filled order.<br /> Quotes are live",

    pick_a_ticker_to_trade: "Pick a Ticker to trade:",
    select_ticker: "Select ticker",

    loading: "Loading..",
    Buy: "Buy",
    Sell: "Sell",
    LIMIT: "LIMIT",
    MARKET: "MARKET",

    amount: "Amount",
    you_have: "You have",
    total: "Total",

    place_buy_order: "Place BUY Order",
    place_sell_order: "Place SELL Order",

    order_placed: "Order placed!",

    you_dont_have_assets: "You don't have assets to trade with",

    orders_history: "Order History",
    orders_open: "Open Orders",
    orders_history_empty: "Order History for {ticker} is Empty",
    orders_open_empty: "No Open Orders for {ticker} at the moment",
    symbol: "Symbol",
    side: "Side",
    type: "Type",
    price: "Price",
    status: "Status",
    stopPrice: "Stop Price",
    executedQty: "ExecQty",
    time: "Time",
    action: "Action",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "CoinTrackr Major update",
        p: [
          "After years of serving dozens and billions of quotes for free for all of our valuable users, CoinTrackr is proud to announce a major Breakthrough, starting today you can track your real Crypto assets you hold on various exchanges right on Cointrackr!",
          "One more thing…. Not only tracking! Cointrackr is also thrilled to announce a Trading feature for thoses assets, It means you’ll be able to track and trade them inside Cointrackr!!",
        ],
      },
      {
        heading: "How it works?",
        p: [
          "Every large exchange allows users to use an API to connect to another platform. For example as you can see below, Binance offer this option at this place:",
          '1) Register to CoinTrackr, then go to menu "Your API Key"',
          "2) Copy paste from your Binance account your API Key and Secret Key.<br /> Here a quick image describing steps:",
          "<em>IMPORTANT</em>: Activate ONLY “<strong>Enable reading</strong>” & “<strong>Enable Spot & Margin Trading</strong>”<br /> And on IP Restriction set CoinTrackr IP address: <strong>{exchangeApiIP}</strong>",
          "Once it’s done, please wait 15mn for Synchronisation purpose, go to the homepage and you will see your asset from your Binance represented by Binance logo.",
          "One important difference also, before on classic CoinTrackr assets you got the Edit button, obviously this button became “Trade”, because from today you can manage and trade your Exchange portfolio right on CoinTrackr.",
          "Let see how your CoinTrack dashboard look like now:",
          "Also now on the first page, you’ll have differentiation with your asset held in Binance and Classic CoinTrackr.",
          "As you can see you have a new column, differentiating your asset per exchange.<br /> > Cointrackr logo is set for your actual classic asset you always tracked.<br /> > Binance here, is your real asset in your Binance live account tracked.",
        ],
      },
      {
        heading: "Trading Platform",
        p: [
          "(Upon acceptance of our Terms & Conditions)",
          "Now let see CoinTrackr trading platform, you can get access to it anytime by clicking “Trade” on every of your exchange asset:",
          "As you can see here, after clicking “Trade” you have options to:<br /> “Buy / Sell”, with two option “Limit order” & “Market” your underlying asset",
          'Note : in order to enable this option, you should choose authorise trading when you create a Binance API with “Enable Spot & Margin Trading” select, please <a href="#step-2-binance-setup">click here to see Binance setup again</a>.',
          "You’ll still be able to track your asset like you did before if you don’t want to use this feature.",
          "Today the first exchange we offer to track is Binance, coming next more of them :)",
          '<a href="mailto:info@cointrackr.com">info@cointrackr.com</a> if you have any questions or if you find a bug. Thanks!',
        ],
      },
    ],
  },
  profitloss: {
    pl: "P/L",
    profitloss: "Profit/Loss",
    realized_profitloss: "Realized Profit/Loss",
    total_balance: "Total Balance",
    mode: "mode",
    portfolio: "Portfolio",
    current: "Current",
    history: "History",
    investment: "Investment",
    average: "Average",
    transaction: "Transaction",
    transactions: "Transactions",
    hide: "Hide",
    show: "Show",
    asset_notes_label: "Notes for this asset",
    asset_notes_placeholder: "Add here any notes related to this Asset group of Transactions",
    reset_portfolio: "Reset Portfolio",
    reset_portfolio_text: "Do you want to delete all Transactions?",
    list_empty: "List is empty.",

    quantity: "Quantity",
    value: "Value",
    date: "Date",
    buy_price: "Buy Price",
    buy_value: "Buy Value",
    buy_date: "Buy Date",
    showInValuation_help: "Include PNL on Current Valuation",
    transaction_notes_placeholder: "Add here any notes related to this Transaction",
    sell_close: "Sell / Close",
    total_valuation: "Total Valuation",
    delete_transaction_text: "Delete this transaction?",

    sell_price: "Sell Price",
    sell_value: "Sell Value",
    sell_date: "Sell Date",
    history_transaction_hint: "This is close Transaction",

    original_buy_transaction: "Original Buy Transaction from {date}",
    left_unsold: "left unsold",
    originally: "originally",
    dependent_transactions: "You have {count} close transactions dependent on this one for {amount} in total",
  },
};
